import { deepMerge, isArray } from 'js/utils/Utils'

const defaults = {}

export default class EventHandler {
  constructor(options = {}) {
    this.handler = []
    deepMerge(this, defaults, options)
  }

  addHandler(task, taskId, handler = this.handler) {
    handler.push({
      task: task,
      taskId: taskId,
    })
  }

  addUnshiftHandler(task, taskId, handler = this.handler) {
    handler.unshift({
      task: task,
      taskId: taskId,
    })
  }

  removeHandler(id, handler = this.handler) {
    if (handler && isArray(handler)) {
      handler.find((item, i) => {
        if (item && item.taskId && item.taskId === id) {
          handler.splice(i, 1)
        }
      })
    }
  }

  destroy() {
    this.handler = []
  }
}